// Function to modify the message based on conditions, language, and translation key
export const ModifyQuestionTranslationText = ({message, params, language}) => {
  // Check if travelers is 1 and modify accordingly

  if (message) {
    if (Number(params?.travelers) <= 1) {
      if (language === 'en') {
        message = message?.replaceAll('persons', 'person');
        message = message?.replaceAll('adults', 'adult');
        message = message?.replaceAll('We', 'I');
      } else if (language === 'nl') {
        message = message?.replaceAll('personen', 'persoon');
        message = message?.replaceAll('volwassenen', 'volwassene');
        message = message?.replaceAll('Wij', 'Ik');
      }
    }

    // Check if infants is 1 and modify accordingly. Zero keeps the plural
    // ("0 children" / "0 kinderen"), which is correct in both languages.
    if (Number(params?.infants) === 1) {
      if (language === 'en') {
        message = message?.replaceAll('children', 'child');
      } else if (language === 'nl') {
        message = message?.replaceAll('kinderen', 'kind');
      }
    }

    // Check if nightsCount is 1 and modify accordingly
    if (Number(params?.nightsCount) <= 1) {
      if (language === 'en') {
        message = message?.replaceAll('nights', 'night');
      } else if (language === 'nl') {
        message = message?.replaceAll('nachten', 'nacht');
      }
    }
  }

  return message;
};

// Fills a {{placeholder}} with a word from the CMS, capitalising the word wherever it
// opens a sentence. The CMS keeps these words lowercase ("flying" / "vliegen") because
// most questions use them mid-sentence, but some locales open with them
// ("{{travel_type}} je nog steeds vanaf {{from}}?"). Surrounding whitespace in the CMS
// value is dropped so it cannot double the space around the placeholder.
export const fillSentenceWord = (message, placeholder, word) => {
  if (!message) return message;

  const value = `${word ?? ''}`.trim();
  const capitalised = value.charAt(0).toUpperCase() + value.slice(1);

  // A sentence starts at the beginning of the message or after ". ", "! " or "? ".
  return message.replace(new RegExp(`{{${placeholder}}}`, 'g'), (match, offset) =>
    /^\s*$|[.!?]\s+$/.test(message.slice(0, offset)) ? capitalised : value,
  );
};
